import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import DashSideBar from "../../shared/DashSideBar";
import "./BusinessServices.css";
import { Editor } from "primereact/editor";

function BusinessServices() {
  let emptyBusinessService = {
    id: null,
    title: "",
    description: "",
    sortOrder: null,
  };
  const [BusinessServices, setBusinessServices] = useState(null);

  const [BusinessServicesDialog, setBusinessServicesDialog] = useState(false);
  const [DeleteBusinessService, setDeleteBusinessService] = useState(false);
  const [DeleteBusinessServicesDialog, setDeleteBusinessServicesDialog] =
    useState(false);
  const [BusinessService, setBusinessService] = useState(emptyBusinessService);
  const [selectedBusinessServices, setSelectedBusinessServices] =
    useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);

  const isFetched = useRef(false);

  useEffect(() => {
    if (!isFetched.current) {
      getBusinessServices();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);
  const getBusinessServices = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Business_services"
      );

      if (response.data) {
        setBusinessServices(response.data);
      }
    } catch (error) {
      console.error("Error fetching BusinessServices:", error);
    }
  };

  const openNew = () => {
    setBusinessService(emptyBusinessService);
    setSubmitted(false);
    setBusinessServicesDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setBusinessServicesDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteBusinessService(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteBusinessServicesDialog(false);
  };

  const saveService = async () => {
    setLoading(true);
    setSubmitted(true);

    try {
      if (BusinessService.title.trim()) {
        let _BusinessServices = [...BusinessServices];
        let _BusinessService = { ...BusinessService };

        if (BusinessService.id) {
          const index = findIndexById(BusinessService.id);

          let formData = new FormData();
          formData.append("id", BusinessService.id); // 👈 Make sure to include ID
          formData.append("title", _BusinessService.title);
          formData.append("description", _BusinessService.description);
          formData.append("sortOrder", _BusinessService.sortOrder);

          const response = await axios.put(
            process.env.REACT_APP_BACKEND_URL +
              "api/Business_services/" +
              BusinessService.id,
            formData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.data) {
            _BusinessServices[index] = _BusinessService;

            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Business Service Updated",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Business Service Not Updated",
              life: 3000,
            });
          }
        } else {
          _BusinessService.id = createId();
          let formData = new FormData();
          formData.append("title", _BusinessService.title);
          formData.append("description", _BusinessService.description);
          formData.append("sortOrder", _BusinessService.sortOrder);

          const response = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "api/Business_services",
            formData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.data) {
            _BusinessServices.push(response.data);
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Business Service Added",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Business Service Not Added",
              life: 3000,
            });
          }
        }

        setBusinessServices(_BusinessServices);
        setBusinessServicesDialog(false);
        setBusinessService(emptyBusinessService);
      }
    } catch (error) {
      console.error("Error during save operation:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "An error occurred while saving the business service. Please try again later.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const editProduct = (BusinessService) => {
    setBusinessService({ ...BusinessService });
    setBusinessServicesDialog(true);
  };

  const confirmDeleteProduct = (BusinessService) => {
    setBusinessService(BusinessService);
    setDeleteBusinessService(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BACKEND_URL +
          "api/Business_services/" +
          BusinessService.id
      );

      setLoading(false);

      if (response.status === 204) {
        // ✅ Check response status instead of data
        let _BusinessServices = BusinessServices.filter(
          (val) => val.id !== BusinessService.id
        );
        setBusinessServices(_BusinessServices);
        setDeleteBusinessService(false);
        setBusinessService(emptyBusinessService);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Business Service Deleted",
          life: 3000,
        });
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Business Service Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < BusinessServices.length; i++) {
      if (BusinessServices[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteBusinessServicesDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedBusinessServices.map(
      (BusinessService) => BusinessService.id
    );
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/Business_services/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _BusinessServices = BusinessServices.filter(
        (val) => !selectedBusinessServices.includes(val)
      );
      setBusinessServices(_BusinessServices);
      setDeleteBusinessServicesDialog(false);
      setSelectedBusinessServices(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Business Services Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Business Services Not Deleted",
        life: 3000,
      });
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _BusinessService = { ...BusinessService };

    _BusinessService[`${name}`] = val;

    setBusinessService(_BusinessService);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Business Services</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={
            !selectedBusinessServices || !selectedBusinessServices.length
          }
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Project Icons</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        style={{ borderRadius: "10px" }}
        onClick={hideDialog}
      />
      <Button
        label="Save"
        loading={loading}
        style={{ borderRadius: "10px" }}
        icon="pi pi-check"
        onClick={saveService}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="BusinessService-container">
          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={BusinessServices}
              selection={selectedBusinessServices}
              onSelectionChange={(e) => setSelectedBusinessServices(e.value)}
              dataKey="id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Project Icons"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                field="title"
                header="Title"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>
              <Column
                field="sortOrder"
                header="Order"
                sortable
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={BusinessServicesDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="BusinessService Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            <div className="field">
              <label htmlFor="title" className="font-bold mb-1">
                Title :
              </label>
              <InputText
                id="title"
                value={BusinessService.title}
                onChange={(e) => onInputChange(e, "title")}
                required
                className={classNames({
                  "p-invalid": submitted && !BusinessService.title,
                })}
              />
              {submitted && !BusinessService.title && (
                <small className="p-error">Title is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="description" className="font-bold mb-1">
                Description :
              </label>
              <Editor
                id="description"
                value={BusinessService.description}
                style={{ height: "100px" }}
                onTextChange={(e) =>
                  onInputChange(
                    { target: { value: e.htmlValue } },
                    "description"
                  )
                }
                required
                className={classNames({
                  "p-invalid": submitted && !BusinessService.description,
                })}
              />
            </div>
            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={BusinessService.sortOrder}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !BusinessService.sortOrder,
                })}
              />
              {submitted && !BusinessService.sortOrder && (
                <small className="p-error">Sort Order is required.</small>
              )}
            </div>
          </Dialog>

          <Dialog
            visible={DeleteBusinessService}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {BusinessService && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{BusinessService.title}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={DeleteBusinessServicesDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {BusinessService && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected Business
                  Services?
                </p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default BusinessServices;
